import AppLayout from '../layouts/Layout'

const SecondPage = () => {
  return (
    <AppLayout>
        <div className='max-w-7xl px-6 lg:px-8'>
            Вот это да
        </div>
    </AppLayout>
  )
}

export default SecondPage